<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="GongYingShangList" data-title="银行账户">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white p-4 rounded-lg">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column
          prop="name"
          label="户名"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="opening_bank"
          label="开户行"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="account"
          label="账户"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="remark"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="状态" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" align="center" :width="320">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}银行账户`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :supplier_id="props.supplier_id"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  supplier_bank_account_page,
  supplier_bank_account_delete,
  supplier_bank_account_updateStatus,
} from "@/http/supplier";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.supplier_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_bank_account_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(supplier_bank_account_delete, row.id, onLoad, {
        filed: "供应商账户",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }该供应商账户吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          supplier_bank_account_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    return { state, props, onLoad, onDelete, onUpdateStatus };
  },
};
</script>

<style lang="scss" scoped></style>
